import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface DeleteFutureBookingsConfirmDialogProps {
  open: boolean;
  /** Delete the future occurrences and save the booking */
  onConfirm: () => void;
  /** Close the confirmation and stay on the booking form */
  onCancel: () => void;
}

export function DeleteFutureBookingsConfirmDialog({
  open,
  onConfirm,
  onCancel,
}: DeleteFutureBookingsConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Future Bookings</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete all future bookings?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>No</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Yes
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
